import { render, staticRenderFns } from "./Distribute_Manage.vue?vue&type=template&id=4b0f8f21&"
import script from "./Distribute_Manage.vue?vue&type=script&lang=js&"
export * from "./Distribute_Manage.vue?vue&type=script&lang=js&"
import style0 from "./Distribute_Manage.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports